(function () {
  function initStickyAtc(stickyBar) {
    var sectionId = stickyBar.dataset.sectionId;
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (!productInfo) return;

    var button = document.getElementById('StickyATCButton-' + sectionId);
    var priceTarget = document.getElementById('StickyATCPrice-' + sectionId);
    var mainPrice = document.getElementById('price-' + sectionId);

    function syncPrice() {
      if (!priceTarget || !mainPrice) return;
      priceTarget.innerHTML = mainPrice.innerHTML;
    }

    function scrollToPurchase() {
      var targets = [
        productInfo.querySelector('[data-type="add-to-cart-form"]'),
        productInfo.querySelector('product-form'),
        productInfo.querySelector('.product-form'),
        productInfo.querySelector('[class*="option-calculator"]'),
        productInfo.querySelector('[class*="product_option"]'),
        productInfo.querySelector('form[action*="/cart/add"]'),
      ];

      for (var i = 0; i < targets.length; i++) {
        if (targets[i]) {
          targets[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }

      productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateVisibility() {
      var rect = productInfo.getBoundingClientRect();
      var show = rect.bottom < window.innerHeight * 0.55;
      stickyBar.hidden = !show;
      stickyBar.classList.toggle('is-visible', show);
    }

    if (button) {
      button.addEventListener('click', scrollToPurchase);
    }

    syncPrice();
    updateVisibility();

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.requestAnimationFrame(syncPrice);
      });
    }

    var priceObserver = mainPrice && typeof MutationObserver !== 'undefined'
      ? new MutationObserver(syncPrice)
      : null;

    if (priceObserver && mainPrice) {
      priceObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }
  }

  document.querySelectorAll('.sticky-atc[data-section-id]').forEach(initStickyAtc);
})();
